/* eslint-disable */
// GENERATED by scripts/help-build.mjs (the light index the top-bar ? reads). Do not edit.
import type { HelpIndexEntry } from '../help-index.js';

export const HELP_INDEX: readonly HelpIndexEntry[] = [
 {
  "id": "ai-receptionist",
  "title": "AI Receptionist: after-hours calls, follow-ups and the family-phone picker",
  "module": "receptionist",
  "modules": [
   "receptionist"
  ],
  "route": "/receptionist"
 },
 {
  "id": "analytics",
  "title": "Analytics, the morning huddle and goals",
  "module": "analytics",
  "modules": [
   "analytics"
  ],
  "route": "/analytics"
 },
 {
  "id": "appearance-switch",
  "title": "Switching the look (Velora, Dentrix, Open Dental or Eaglesoft)",
  "module": "settings",
  "modules": [
   "settings",
   "shell"
  ],
  "route": "/settings/appearance"
 },
 {
  "id": "ask-velora",
  "title": "Asking the AI assistant (Ask Velora)",
  "module": "assistant",
  "modules": [
   "assistant"
  ],
  "route": "/assistant"
 },
 {
  "id": "billing-ledger",
  "title": "Billing, the ledger and taking payments",
  "module": "ledger",
  "modules": [
   "ledger",
   "worklists"
  ],
  "route": "/billing"
 },
 {
  "id": "chart-perio-notes",
  "title": "Charting, perio and clinical notes",
  "module": "chart",
  "modules": [
   "chart",
   "perio",
   "notes"
  ],
  "route": "/charting"
 },
 {
  "id": "checkout-front-desk",
  "title": "Checkout, close the day, tasks and documents",
  "module": "frontdesk",
  "modules": [
   "frontdesk"
  ],
  "route": "/frontdesk"
 },
 {
  "id": "claims-insurance",
  "title": "Claims, insurance eligibility and plans",
  "module": "claims",
  "modules": [
   "claims",
   "eligibility",
   "insurance-plans"
  ],
  "route": "/claims"
 },
 {
  "id": "clinic-flow",
  "title": "Room turnover, Light Board, sterilization and Radio",
  "module": "chairside",
  "modules": [
   "chairside",
   "lightboard",
   "sterilization",
   "radio"
  ],
  "route": "/turnover"
 },
 {
  "id": "coaching-booking",
  "title": "Coaching lesson: Offering times first",
  "module": "coaching",
  "modules": [
   "coaching"
  ],
  "route": "/coaching"
 },
 {
  "id": "coaching-closing",
  "title": "Coaching lesson: A clear next step",
  "module": "coaching",
  "modules": [
   "coaching"
  ],
  "route": "/coaching"
 },
 {
  "id": "coaching-greeting",
  "title": "Coaching lesson: A warm greeting",
  "module": "coaching",
  "modules": [
   "coaching"
  ],
  "route": "/coaching"
 },
 {
  "id": "coaching-listening",
  "title": "Coaching lesson: Finding the need",
  "module": "coaching",
  "modules": [
   "coaching"
  ],
  "route": "/coaching"
 },
 {
  "id": "coaching-resolution",
  "title": "Coaching lesson: Solving the need",
  "module": "coaching",
  "modules": [
   "coaching"
  ],
  "route": "/coaching"
 },
 {
  "id": "coaching",
  "title": "Coaching: your weekly report card and one habit",
  "module": "coaching",
  "modules": [
   "coaching"
  ],
  "route": "/coaching"
 },
 {
  "id": "communications-texting",
  "title": "Communications: two-way texting, Unanswered and Missed-call replies",
  "module": "inbox",
  "modules": [
   "inbox"
  ],
  "route": "/communications"
 },
 {
  "id": "day-end-reports",
  "title": "Day-end reports (day sheet, deposit, deleted transactions)",
  "module": "analytics",
  "modules": [
   "analytics"
  ],
  "route": "/analytics/day-end"
 },
 {
  "id": "desktop-app",
  "title": "The Velora desktop app for Windows",
  "module": "settings",
  "modules": [
   "settings"
  ],
  "route": "/download"
 },
 {
  "id": "feature-requests",
  "title": "Feature requests and reporting a problem",
  "module": "feedback",
  "modules": [
   "feedback"
  ],
  "route": "/feedback"
 },
 {
  "id": "forms-portal",
  "title": "Patient forms and the patient portal",
  "module": "forms",
  "modules": [
   "forms",
   "portal"
  ],
  "route": "/forms"
 },
 {
  "id": "help-center",
  "title": "Using the Help Center",
  "module": "help",
  "modules": [
   "help"
  ],
  "route": "/help"
 },
 {
  "id": "home-waiting-on-us",
  "title": "Home and the \"Waiting on us\" bar",
  "module": "home",
  "modules": [
   "home"
  ],
  "route": "/home"
 },
 {
  "id": "imaging",
  "title": "Imaging and x-rays",
  "module": "imaging",
  "modules": [
   "imaging",
   "imaging-devices",
   "imaging-sources"
  ],
  "route": "/imaging"
 },
 {
  "id": "inventory-membership",
  "title": "Inventory and membership plans",
  "module": "inventory",
  "modules": [
   "inventory",
   "membership"
  ],
  "route": "/inventory"
 },
 {
  "id": "lab-referrals",
  "title": "Lab cases and referrals",
  "module": "lab",
  "modules": [
   "lab",
   "referrals"
  ],
  "route": "/lab"
 },
 {
  "id": "leads-web-leads",
  "title": "Leads: website chats, web forms and new callers",
  "module": "leads",
  "modules": [
   "leads"
  ],
  "route": "/leads"
 },
 {
  "id": "marketing-reviews",
  "title": "Marketing ROI and reviews",
  "module": "growth",
  "modules": [
   "growth",
   "reviews"
  ],
  "route": "/growth"
 },
 {
  "id": "marketplace-ai-usage",
  "title": "Marketplace and AI usage",
  "module": "marketplace",
  "modules": [
   "marketplace",
   "ai-usage"
  ],
  "route": "/marketplace"
 },
 {
  "id": "office-manager",
  "title": "Office Manager: what to change, your team and each office's check-in",
  "module": "council",
  "modules": [
   "council"
  ],
  "route": "/council"
 },
 {
  "id": "openings-online-booking",
  "title": "Openings (filling holes) and online booking requests",
  "module": "gap-fill",
  "modules": [
   "gap-fill",
   "booking"
  ],
  "route": "/schedule/openings"
 },
 {
  "id": "patients-family-file",
  "title": "Patients and the Family File",
  "module": "patients",
  "modules": [
   "patients",
   "patient-brief"
  ],
  "route": "/patients"
 },
 {
  "id": "phones-missed-calls",
  "title": "Phones: missed calls and marking called back",
  "module": "phones",
  "modules": [
   "phones"
  ],
  "route": "/phones"
 },
 {
  "id": "popout-windows",
  "title": "Pop-out windows (second monitor and split screen)",
  "module": "shell",
  "modules": [
   "shell"
  ],
  "route": "/schedule"
 },
 {
  "id": "prescriptions",
  "title": "Prescriptions (Rx)",
  "module": "rx",
  "modules": [
   "rx"
  ],
  "route": "/rx"
 },
 {
  "id": "recall-outreach",
  "title": "Recall, worklists and patient outreach",
  "module": "recall",
  "modules": [
   "recall",
   "care-outreach",
   "reminders",
   "campaigns"
  ],
  "route": "/recall"
 },
 {
  "id": "reviews-requests",
  "title": "Review requests (replacing Doctible)",
  "module": "reviews",
  "modules": [
   "reviews"
  ],
  "route": "/reviews"
 },
 {
  "id": "schedule-booking",
  "title": "The schedule and booking an appointment (including at another office)",
  "module": "schedule",
  "modules": [
   "schedule"
  ],
  "route": "/schedule"
 },
 {
  "id": "schedule-confirmations",
  "title": "Confirming appointments",
  "module": "schedule",
  "modules": [
   "schedule",
   "inbox"
  ],
  "route": "/schedule"
 },
 {
  "id": "settings-communications",
  "title": "Communications settings (reminders, reviews, missed-call and auto-reply texts)",
  "module": "settings",
  "modules": [
   "settings",
   "reviews",
   "reminders",
   "recall",
   "phones",
   "inbox",
   "payments"
  ],
  "route": "/settings/communications"
 },
 {
  "id": "signing-in",
  "title": "Signing in to Velora (and your first sign-in)",
  "module": "identity",
  "modules": [
   "identity",
   "settings"
  ],
  "route": "/login"
 },
 {
  "id": "system-data",
  "title": "PulseSync, sync status, audit log, codes and migration",
  "module": "connector-health",
  "modules": [
   "connector-health",
   "sync-status",
   "system",
   "migration",
   "audit",
   "codes"
  ],
  "route": "/settings/sync-status"
 },
 {
  "id": "team-timeclock",
  "title": "Time clock, timesheets and Team & HR",
  "module": "timeclock",
  "modules": [
   "timeclock",
   "hr"
  ],
  "route": "/timesheets"
 },
 {
  "id": "treatment-plans",
  "title": "Treatment plans and case acceptance",
  "module": "txplan",
  "modules": [
   "txplan",
   "case-closed"
  ],
  "route": "/treatment-plans"
 },
 {
  "id": "users-roles",
  "title": "Users and roles (for office managers)",
  "module": "identity",
  "modules": [
   "identity"
  ],
  "route": "/settings/users"
 }
];
